import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './AssignmentBtn.module.scss';

const AssignmentBtn: React.FC = () => {
	return (
		<Link className={style.container} to="/menu/dishes-assignment" data-test="AssignmentBtn">
			<Button
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#list`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="assignmentButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default AssignmentBtn;
